import { HasProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { css } from "styled-components";
import { connect, ResolveThunks } from "react-redux";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import updateCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";


const mapDispatchToProps = {
    addToCart: makeHandlerChainAwaitable<Parameters<typeof addToCart>[0], CartLineModel>(addToCart),
    updateCartLine: makeHandlerChainAwaitable<Parameters<typeof updateCartLine>[0], CartLineModel>(updateCartLine),
};

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {

    return {
        
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasHistory & ResolveThunks<typeof mapDispatchToProps> & HasProduct;


export interface AHRIRedirectWidgetStyles {
    spinner?: LoadingSpinnerProps;
    centeringWrapper?: InjectableCss;
}

export const AHRIRedirectWidgetStyles: AHRIRedirectWidgetStyles = {
    spinner: {
        css: css`
            margin: 0 auto;
        `,
    },
    centeringWrapper: {
        css: css`
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
};


const styles = AHRIRedirectWidgetStyles;
const StyledSpan = getStyledWrapper("span");
let didExecute = false;

export const AHRIAddToCart: React.FC<Props> = ({addToCart, updateCartLine, history}) => {
    React.useEffect(() =>{
        console.log(`${didExecute} didExecute`);
        if(!didExecute)
        {
            didExecute = true;
            const addToCartAHRIClickHandler = async(productId: string, quantity: string, ahri: string) => {
                const prefaceText = "AHRI Number(s) - Do not edit: ";
    
                const notes = prefaceText + ahri;
                console.log(`${productId} - ${quantity} - ${ahri} before addToCart`);
    
                const cartline = (await addToCart({
                    productId: productId,
                    qtyOrdered: parseInt(quantity),
                    unitOfMeasure: "EA",
                    notes: notes
                })) as CartLineModel;
    
                console.log(`${productId} - ${quantity} - ${ahri} after addToCart`);
    
                const notesAreDifferent = notes !== cartline.notes;
                const ahriNumbersOnCartLine = cartline.notes.replace(prefaceText, "").replace(/ /g, "").split(",").sort();
                const ahriNumberNotOnLine = ahriNumbersOnCartLine.includes(ahri) === false;
                if (notesAreDifferent && ahriNumberNotOnLine) {
    
                    const newNotes = `${cartline.notes}, ${ahri}`;
    
                    cartline.notes = newNotes;
                    console.log(`${productId} - ${quantity} - ${ahri} before updateCartLine`);
    
                    await updateCartLine({
                        cartLine: {
                            ...cartline,
                            notes: newNotes,
                        },
                        shouldNotReloadPromotions: true,
                        shouldNotLoadFullCart: true
                    });
                    console.log(`${productId} - ${quantity} - ${ahri} after updateCartLine`);
    
                }
            }
            const params = new URLSearchParams(window.location.search)
            var productIds  = [], quantities  = [], ahriNumbers  = [];
            for (const [key, value] of params.entries()) {
                if(key.indexOf("productId") >= 0){
                    productIds.push(value)
                }
                if(key.indexOf("qty") >= 0){
                    quantities.push(value)
                }
                if(key.indexOf("ahri") >= 0){
                    ahriNumbers.push(value)
                }
            }
            const addItemsToCart = async(productIds: string[], quantities: string[], ahriNumbers: string[]) => {
                const promises = [];
                console.log(`${productIds.length} productIds.length`);
                for(var i = 0; i < productIds.length; i++){
                    console.log(`${productIds[i]} - ${quantities[i]} - ${ahriNumbers[i]} - ${i} Promise Adding`);
                    promises.push(await addToCartAHRIClickHandler(productIds[i], quantities[i], ahriNumbers[i]));
                }
            }
                    
            addItemsToCart(productIds, quantities, ahriNumbers).then(() => {
                if(productIds.length > 0){
                    history.push("/cart");
                }
            })
        }
    },[]);
    
    return (
        <>
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    //connect(mapStateToProps)(withProductContext(ProductDetailsPrice))
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(AHRIAddToCart)),
    definition: {
        group: "Common",
        icon: "link",
        displayName: "AHRI Add To Cart",
        fieldDefinitions: [
            
        ],
    },
};

export default widgetModule;
